export const VIEWER_RESTRICTED_MESSAGE =
  "You don't have permissions for this. Contact your admin to update your permissions.";
export const VIEWER_BANNER_LABEL = 'Viewer';
export const VIEWER_BANNER_MESSAGE = "You can browse, but can't make changes.";
export const VIEWER_BANNER_REDACTED_MESSAGE =
  "You can browse, but can't make changes. Some information may be redacted.";
